import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import './design-guidelines-styles.css';
export const _frontmatter = {
  "pageTitle": "Tooltip Design Guidelines",
  "title": "Tooltip",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PageContent componentName="tooltip" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  Tooltips display informative text when users hover over, or focus on an
  element.
      </LeadParagraph>
      <h2>{`Usage`}</h2>
      <p>{`Tooltips are necessary for interactive elements whose function may not be clearly spelled out within the element itself. This is especially valuable for elements that are represented only by an image or icon. Tooltips should always be paired closely with the element with which they are associated. The message within the tooltip should always be kept as short and clear as possible.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "69.88416988416989%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAnElEQVQoz82SQQrCMBBFe7vmYMllFBsQwQNkIz2CIAghF5iZpjNdZIpdN9LqQt/+8T7DNMMXNH8pIxIRfSITDdMkIvxGr8k0jnzoHqfzk0Vq/aqcM1+u6djdATDnnbMRMcbY97eUEjOvxldkAFBV770xpm2N915VAWCTjIillBCCc85aG0IopSDi1tlEJCK6IPsP9urDwmrz1+85AzXvF8LYqJ9gAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/static/913562385fde71df7ad247168ac42d33/8ae3e/Tooltip-imagery.png",
                  "srcSet": ["/static/913562385fde71df7ad247168ac42d33/a2ead/Tooltip-imagery.png 259w", "/static/913562385fde71df7ad247168ac42d33/6b9fd/Tooltip-imagery.png 518w", "/static/913562385fde71df7ad247168ac42d33/8ae3e/Tooltip-imagery.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-correct"
                }}>{`Correct`}</p>{`
          `}<p parentName="figcaption">{`Use tooltips for interactive imagery like icon buttons.`}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "69.88416988416989%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA7klEQVQoz73SsWrCUBQGYJ/G2cHRJ2h0qVs79QFciotD0MFnsW0ydCsUhKAEUdHdpWgy1C4X5Jzjubea5Eh1qFsSFH/+9RvO4S9sL0jh+piIEP9LRDmw0Zwk5lRJjDFMWTDR1hhe/2yGfjjww6EfeoPwe73585SGAUhk/+IuiqXX+uPn3f1HudJz3xciewBKwYgk8tv3lg9P3nNr2miO293+aPyVxDtESr8ZEeM4ms3mtt2x7c5kMo+iCBEzPQwARMRxnFqtalmW676JCABk/TYzK6VWqyAIAqUUM+cbidZ6d4zWOvfC6Cw3nGdGfABQOwrlQTmvdQAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/static/47f0ff2e8061205c412ced569361a910/8ae3e/Tooltip-repeat-word.png",
                  "srcSet": ["/static/47f0ff2e8061205c412ced569361a910/a2ead/Tooltip-repeat-word.png 259w", "/static/47f0ff2e8061205c412ced569361a910/6b9fd/Tooltip-repeat-word.png 518w", "/static/47f0ff2e8061205c412ced569361a910/8ae3e/Tooltip-repeat-word.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-incorrect"
                }}>{`Incorrect`}</p>{`
          `}<p parentName="figcaption">{`Don’t use tooltips to restate visible UI text.`}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
  `}</div>
      </div>
      <hr></hr>
      <h2>{`Placement`}</h2>
      <p>{`Tooltips can be positioned below, above, to the right of, or to the left of the element they are associated with. The tooltip will automatically adjust its position to ensure it stays within the visible area of your browser window.`}</p>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "25.096525096525095%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAIAAADKYVtkAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA5ElEQVQY0z3QsU7DQAwG4Lw2EksmGFgq0YklQmFHdOMB2iGIhSFJVZZSpIvSXJ072znnhA7dRfBttmTJ/58RESISWUqstSISQpjnOe3ROXYJMyPilDAzEWVEcUb8YZ4Q42XbtkXxsNttvfcApuug73ulFAAYY85Rf7kAImfMrLUun573+4OImyY+nb6vrovq7SMEf/g836226/V9nudVVdV1fRvdvGxej1+QOeeUUmX52DSNiFhrJifVezea+Jq1qDUsrLXGGK31MAwAI8CYLTFCCCKCCRF5z6mLWAf/WUr5z8zMvx9TD+FVq59rAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": " ",
            "title": " ",
            "src": "/static/8c70b4b0b041b9e0ad0cbc398ea35458/e3189/Tooltip-positions.png",
            "srcSet": ["/static/8c70b4b0b041b9e0ad0cbc398ea35458/a2ead/Tooltip-positions.png 259w", "/static/8c70b4b0b041b9e0ad0cbc398ea35458/6b9fd/Tooltip-positions.png 518w", "/static/8c70b4b0b041b9e0ad0cbc398ea35458/e3189/Tooltip-positions.png 1035w", "/static/8c70b4b0b041b9e0ad0cbc398ea35458/44d59/Tooltip-positions.png 1553w", "/static/8c70b4b0b041b9e0ad0cbc398ea35458/6568d/Tooltip-positions.png 1660w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
      <hr></hr>
      <h2>{`Accessibility`}</h2>
      <p>{`Tooltips are displayed when hovering over or focusing on an element, but they are also announced to screen readers for the visually impaired. Users navigating the page with a keyboard will see the tooltip when they move focus to the element, and may dismiss the tooltip by pressing the `}<inlineCode parentName="p">{`Escape`}</inlineCode>{` key.`}</p>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      